import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { FileResolutionData } from '../../models/uploaded-image-resolution.model';

export const setFilesResolution = createAction(
  '[Files Resolution] set files resolution data',
  props<{ files: File[]; resolutionData: FileResolutionData[] }>(),
);

export const updateFileResolution = createAction(
  '[Files Resolution] update file resolution data',
  props<{ update: Update<FileResolutionData> }>(),
);

export const removeFileResolution = createAction(
  '[Files Resolution] remove file resolution data',
  props<{ name: string }>(),
);

export const removeAllFilesResolution = createAction(
  '[Files Resolution] remove all files resolution data',
);
